export default function BackgroundOrbs() {
  return (
    <div className="fixed inset-0 pointer-events-none z-0">
      {/* Orb 1 - Top Right */}
      <div
        className="absolute top-[10%] right-[10%] w-[400px] h-[400px] rounded-full blur-[40px] animate-float-slow"
        style={{
          background: 'radial-gradient(circle, rgba(20, 184, 166, 0.08) 0%, transparent 70%)',
        }}
      />

      {/* Orb 2 - Middle Left */}
      <div
        className="absolute top-[50%] -left-[5%] w-[300px] h-[300px] rounded-full blur-[40px] animate-float-slow"
        style={{
          background: 'radial-gradient(circle, rgba(20, 184, 166, 0.06) 0%, transparent 70%)',
        }}
      />

      {/* Orb 3 - Bottom Right */}
      <div
        className="absolute bottom-[10%] right-[20%] w-[350px] h-[350px] rounded-full blur-[40px] animate-float-slow"
        style={{
          background: 'radial-gradient(circle, rgba(20, 184, 166, 0.05) 0%, transparent 70%)',
        }}
      />
    </div>
  )
}
